module.exports = __webpack_public_path__ + "static/media/image-3.2b7fdd31.jpg";